import { login, logout, getContext, updateBillingInformation } from '@/api/users'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    email: '',
    sentri: '',
    rfc: '',
    address: '',
    phone: '',
    billing_email: '',
    billing_name: '',
    billing_rfc: '',
    stall_key: '',
    terms_accepted: false,
    user_type: 'normal',
    balance: 0,
    formattedBalance: '',
    names: '',
    father_lastname: '',
    country: '',
    city: '',
    state: '',
    street: '',
    postal_code: '',
    hasPendingInvoices: false,
    pendingInvoicesCount: 0
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
    removeToken()
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_DATA: (state, data) => {
    state.name = data.name
    state.email = data.email
    state.sentri = data.sentri
    state.rfc = data.rfc
    state.address = data.address
    state.phone = data.phone
    state.billing_name = data.billing_name
    state.billing_email = data.billing_email
    state.billing_rfc = data.billing_rfc
    state.stall_key = data.stall_key
    state.terms_accepted = data.terms_accepted
    state.user_type = data.user_type
    state.balance = data.balance
    state.formattedBalance = data.formatted_balance
    state.hasPendingInvoices = data.has_pending_invoices
    state.pendingInvoicesCount = data.pending_invoices_count
  },
  SET_BILLING_DATA: (state, data) => {
    state.billing_name = data.billing_name
    state.billing_email = data.billing_email
    state.billing_rfc = data.billing_rfc
  }
}

const actions = {
  // user login
  login ({ commit }, session) {
    return new Promise((resolve, reject) => {
      login({ session }).then(response => {
        const { data } = response
        commit('SET_DATA', data)
        commit('SET_TOKEN', data.auth_token)
        setToken(data.auth_token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  // user logout
  logout ({ commit }) {
    return new Promise((resolve, reject) => {
      logout().then(() => {
        removeToken()
        resetRouter()
        commit('RESET_STATE')
        resolve()
      }).catch(_ => {
        // Doesn't really matter
        removeToken()
        resetRouter()
        commit('RESET_STATE')
        resolve()
      })
    })
  },
  // get context
  context ({ commit }) {
    return new Promise((resolve, reject) => {
      getContext().then(response => {
        const { data } = response
        commit('SET_DATA', data)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  updateBillingInformation ({ commit }, data) {
    return new Promise((resolve, reject) => {
      updateBillingInformation(data).then(response => {
        commit('SET_BILLING_DATA', response.data)
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

const getters = {
  userIsCompanyAdmin: (state, getters) => {
    return getters.userType === 'company'
  },
  userIsCompanyType: (state, getters) => {
    return getters.userIsCompanyAdmin || getters.userIsOperator || getters.userIsReporter
  },
  userIsNormalType: (state, getters) => {
    return getters.userType === 'normal'
  },
  userIsOperator: (state, getters) => {
    const userRole = getters.userRole

    if (userRole) {
      return userRole === 'operator'
    }

    return false
  },
  userIsReporter: (state, getters) => {
    const userRole = getters.userRole

    if (userRole) {
      return userRole === 'reporter'
    }

    return false
  },
  userRole: (state, getters) => {
    if (getters.userType === 'sub_user') {
      return JSON.parse(atob(state.token.split('.')[1])).role
    }

    return null
  },
  userType: state => {
    if (state.token) {
      return JSON.parse(atob(state.token.split('.')[1])).user_type
    }

    return ''
  },
  userHasPendingInvoices: state => state.hasPendingInvoices && (state.pendingInvoicesCount > 0),
  userPendingInvoicesCount: state => state.pendingInvoicesCount
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
